import getIdReduxUtil from 'modules/redux/utils/get-id'
import {
  WORKOUT_EXERCISES_DOMAIN,
  WORKOUTS_DOMAIN,
  WORKOUTS_KEY,
  WORKOUTS_PATH
} from 'modules/workout/redux/constants'
import getByIdReduxSelector from 'modules/redux/selectors/get-by-id'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import {
  getByIdWorkoutSectionSelector,
  getCurrentProfileSelect,
  getRoundsWorkoutSectionUtil,
  WORKOUT_EXERCISE_KEY,
  WORKOUT_KEY,
  WORKOUT_SECTION_KEY
} from '@gymaholic/packages'
import { subDays } from 'date-fns'
import isLoadingReduxUtil from 'modules/redux/utils/is-loading'
import isLoadedReduxSelector from 'modules/redux/utils/is-loaded'
import {
  getObjectUtil,
  isSameDayDateUtil
} from 'packages/src'

export const getRecommendedWorkoutsSelector = () => {
  return (state) => {
    const recommended = state[WORKOUTS_DOMAIN][WORKOUTS_KEY.RECOMMENDED]
    if (recommended) {
      return recommended[WORKOUTS_KEY.DATA]
    }
  }
}

export function getByIdWorkoutSelector (id) {
  return (state) => {
    return getByIdReduxSelector(WORKOUTS_PATH.DATA, id)(state)
  }
}

export function getByIdParamWorkoutSelector () {
  return (state, props) => {
    const id = getObjectUtil(props, 'match.params.id')
    return getByIdReduxSelector(WORKOUTS_PATH.DATA, id)(state)
  }
}

export function getByIdPropWorkoutSelector () {
  return (state, props) => {
    return (
      getByIdReduxSelector(
        WORKOUTS_PATH.DATA,
        props.id
      )(state)
    )
  }
}

export function getByIdWorkoutSectionIndexSelector (instance, workoutSectionId) {
  return (state) => {
    const workoutSections = getValueReduxUtil(instance, WORKOUT_KEY.WORKOUT_SECTIONS)

    let index
    if (workoutSections) {
      index = workoutSections.findIndex(workoutSection => getIdReduxUtil(workoutSection) === Number(workoutSectionId))
    }

    return index
  }
}

export function getCombinedSetDataSelector (workoutExercisesFromSection) {
  return (state) => {
    const combinedSetData = []

    if (workoutExercisesFromSection) {
      workoutExercisesFromSection.map((workoutExercise, index) => {
        const workoutExerciseId = getIdReduxUtil(workoutExercise)
        const workoutExerciseCompleteObject = getByIdReduxSelector(`${WORKOUT_EXERCISES_DOMAIN}.data`, workoutExerciseId)(state)
        const setData = getValueReduxUtil(workoutExerciseCompleteObject, WORKOUT_EXERCISE_KEY.SET_DATA)

        return setData.map((setDataItem, setIndex) => {
          return combinedSetData.push({
            ...workoutExercise,
            setData: setDataItem,
            workoutExerciseIndex: index,
            originalSetIndexInsideWorkoutExerciseObj: setIndex
          })
        })
      })
    }
    return combinedSetData
  }
}

export function getRoundsSetDataSelector (workoutExercisesFromSection) {
  return (state) => {
    const workoutExercises = state[WORKOUT_EXERCISES_DOMAIN]
    const filteredWorkoutExercises = []
    const rounds = []

    if (workoutExercisesFromSection) {
      workoutExercisesFromSection.map((workoutExerciseFromSection) => {
        return filteredWorkoutExercises.push(workoutExercises.data[getIdReduxUtil(workoutExerciseFromSection)])
      })

      const roundsData = getRoundsWorkoutSectionUtil(filteredWorkoutExercises)

      roundsData.map((roundData, index) => {
        const combinedSetData = []
        roundData.map((roundSetData) => {
          const workoutExercise = workoutExercisesFromSection.filter((workoutExercise) => getIdReduxUtil(workoutExercise) === roundSetData.workoutExerciseId)
          const workoutExerciseIndex = workoutExercisesFromSection.indexOf(workoutExercise[0])
          return combinedSetData.push({
            ...workoutExercise[0],
            setData: roundSetData.set,
            workoutExerciseIndex,
            originalSetIndexInsideWorkoutExerciseObj: roundSetData.setIndex
          })
        })

        return rounds.push({
          roundIndex: index,
          combinedSetData
        })
      })
    }

    return rounds
  }
}

export const getPreviousWorkoutSectionSelector = (workoutSections) => {
  return (state) => {
    const currentWorkoutSectionIndex = state.startWorkout.currentWorkoutSectionIndex
    let previousWorkoutSection

    if (workoutSections && currentWorkoutSectionIndex > 0) {
      let previousIndex = currentWorkoutSectionIndex - 1
      let isWorkoutSectionExercisesEmpty = true
      do {
        if (previousIndex >= 0) {
          previousWorkoutSection = getByIdWorkoutSectionSelector(getIdReduxUtil(workoutSections[previousIndex]))(state)
          const workoutExercises = getValueReduxUtil(previousWorkoutSection, WORKOUT_SECTION_KEY.WORKOUT_EXERCISES)
          isWorkoutSectionExercisesEmpty = workoutExercises && workoutExercises.length === 0
          previousIndex = previousIndex - 1
        } else {
          previousWorkoutSection = undefined
          break
        }
      } while (isWorkoutSectionExercisesEmpty === true)
    }

    return previousWorkoutSection
  }
}

export const getNextWorkoutSectionSelector = (workoutSections) => {
  return (state) => {
    const currentWorkoutSectionIndex = state.startWorkout.currentWorkoutSectionIndex
    let nextWorkoutSection

    if (workoutSections && currentWorkoutSectionIndex < workoutSections.length - 1) {
      let nextIndex = currentWorkoutSectionIndex + 1
      let isWorkoutSectionExercisesEmpty = true
      do {
        if (nextIndex < workoutSections.length - 1) {
          nextWorkoutSection = getByIdWorkoutSectionSelector(getIdReduxUtil(workoutSections[nextIndex]))(state)
          const workoutExercises = getValueReduxUtil(nextWorkoutSection, WORKOUT_SECTION_KEY.WORKOUT_EXERCISES)
          isWorkoutSectionExercisesEmpty = workoutExercises && workoutExercises.length === 0
          nextIndex = nextIndex + 1
        } else {
          nextWorkoutSection = undefined
          break
        }
      } while (isWorkoutSectionExercisesEmpty === true)
    }

    return nextWorkoutSection
  }
}

export const getByIdExerciseSelector = (id) => {
  return state => state && state.exercises.data[id]
}

export const isLoadingWorkoutsLoggedSelector = () => {
  return (state) => {
    const currentProfile = getCurrentProfileSelect(state)
    const workouts = state[WORKOUTS_DOMAIN]
    if (workouts.byProfileId && workouts.byProfileId[getIdReduxUtil(currentProfile)]) {
      return isLoadingReduxUtil(workouts.byProfileId[getIdReduxUtil(currentProfile)]?.logged)
    }
  }
}

export const isLoadedWorkoutsLooggedSelector = () => {
  return (state) => {
    const currentProfile = getCurrentProfileSelect(state)
    const workouts = state[WORKOUTS_DOMAIN]
    if (workouts.byProfileId && workouts.byProfileId[getIdReduxUtil(currentProfile)]) {
      return isLoadedReduxSelector(workouts.byProfileId[getIdReduxUtil(currentProfile)]?.logged)
    }
  }
}

export const getWorkoutsLoggedGraphDataSelector = () => {
  return (state) => {
    const workouts = state[WORKOUTS_DOMAIN]
    if (workouts.byProfileId) {
      const currentProfile = getCurrentProfileSelect(state)
      const loggedWorkoutsIds = workouts.byProfileId[getIdReduxUtil(currentProfile)]?.logged

      if (loggedWorkoutsIds && loggedWorkoutsIds.data !== undefined) {
        // Finding dates of the week to show
        let currentDate = new Date()
        const dates = []
        for (let i = 0; i < 7; i++) {
          if (i === 0) {
            dates.push(currentDate)
            continue
          }
          const newDate = subDays(currentDate, 1)
          currentDate = newDate
          dates.push(newDate)
        }
        dates.reverse()

        const loggedWorkoutsObjs = []
        loggedWorkoutsIds.data.map((loggedWorkoutId, index) => {
          return loggedWorkoutsObjs.push(workouts.data[loggedWorkoutId])
        })

        let countGraphData = []
        let caloriesGraphData = []
        let volumeGraphData = []
        let maximumCount = 0
        let minimumCount = 0
        let maximumCalories = 0
        let minimumCalories = 0
        let maximumVolume = 0
        let minimumVolume = 0

        let totalCaloriesOfWeek = 0
        let totalVolumeOfWeek = 0
        let volumeAvailableInWeekCount = 0
        let loggedWorkoutsOfWeekCount = 0
        let totalDurationOfWeek = 0

        dates.map((date) => {
          const loggedWorkoutsAtDate = loggedWorkoutsObjs.filter((loggedWorkout) => {
            const loggedAt = new Date(getValueReduxUtil(loggedWorkout, WORKOUT_KEY.LOGGED_AT))
            return isSameDayDateUtil(loggedAt, date)
          })

          let totalCaloriesOfDate = 0
          let totalVolumeOfDate = 0
          loggedWorkoutsOfWeekCount = loggedWorkoutsOfWeekCount + loggedWorkoutsAtDate.length

          if (loggedWorkoutsAtDate.length > 0) {
            loggedWorkoutsAtDate.map((loggedWorkout) => {
              const calories = getValueReduxUtil(loggedWorkout, WORKOUT_KEY.CALORIES)
              const estimatedCalories = getValueReduxUtil(loggedWorkout, WORKOUT_KEY.ESTIMATED_CALORIES)
              const trainingVolume = getValueReduxUtil(loggedWorkout, WORKOUT_KEY.TRAINING_VOLUME)
              const estimatedTrainingVolume = getValueReduxUtil(loggedWorkout, WORKOUT_KEY.ESTIMATED_TRAINING_VOLUME)
              const duration = getValueReduxUtil(loggedWorkout, WORKOUT_KEY.DURATION)

              totalCaloriesOfDate = totalCaloriesOfDate + (calories || estimatedCalories)
              totalCaloriesOfWeek = totalCaloriesOfWeek + (calories || estimatedCalories)
              totalVolumeOfDate = totalVolumeOfDate + (trainingVolume || estimatedTrainingVolume)
              totalVolumeOfWeek = totalVolumeOfWeek + (trainingVolume || estimatedTrainingVolume)
              totalDurationOfWeek = totalDurationOfWeek + duration

              if (totalVolumeOfDate > 0) {
                totalVolumeOfDate = Number((totalVolumeOfDate / 1000).toFixed(1))
              }
              if (trainingVolume || estimatedTrainingVolume) {
                volumeAvailableInWeekCount = volumeAvailableInWeekCount + 1
              }
              return null
            })
          }

          // Finding max, min count
          if (loggedWorkoutsAtDate.length > maximumCount) {
            maximumCount = loggedWorkoutsAtDate.length
          }
          if (loggedWorkoutsAtDate.length < minimumCount) {
            minimumCount = loggedWorkoutsAtDate.length
          }

          // Finding max, min calories
          if (totalCaloriesOfDate > maximumCalories) {
            maximumCalories = totalCaloriesOfDate
          }
          if (totalCaloriesOfDate < minimumCalories) {
            minimumCalories = totalCaloriesOfDate
          }

          // Finding max, min trainingVolume
          if (totalVolumeOfDate > maximumVolume) {
            maximumVolume = totalVolumeOfDate
          }
          if (totalVolumeOfDate < minimumVolume) {
            minimumVolume = totalVolumeOfDate
          }

          // Subtracting some amount of value from y, to show some padding between bars and maximum y value
          const percentageToSubtract = 0.07

          countGraphData.unshift({
            x: date,
            y: loggedWorkoutsAtDate.length > 0
              ? loggedWorkoutsAtDate.length - (loggedWorkoutsAtDate.length * percentageToSubtract)
              : 0
          })
          caloriesGraphData.unshift({
            x: date,
            y: totalCaloriesOfDate > 0
              ? totalCaloriesOfDate - (totalCaloriesOfDate * percentageToSubtract)
              : 0
          })
          volumeGraphData.unshift({
            x: date,
            y: totalVolumeOfDate > 0
              ? totalVolumeOfDate - (totalVolumeOfDate * percentageToSubtract)
              : 0
          })
          return null
        })

        countGraphData = countGraphData.map((data) => {
          if (data.y === 0) {
            return {
              x: data.x,
              y: maximumCount * 0.01
            }
          }
          return data
        })
        caloriesGraphData = caloriesGraphData.map((data) => {
          if (data.y === 0) {
            return {
              x: data.x,
              y: maximumCalories * 0.01
            }
          }
          return data
        })
        volumeGraphData = volumeGraphData.map((data) => {
          if (data.y === 0) {
            return {
              x: data.x,
              y: maximumVolume * 0.01
            }
          }
          return data
        })

        const countDomain = {
          y: [
            minimumCount,
            maximumCount === 0 ? 1 : maximumCount
          ]
        }
        const countTickValues = [
          minimumCount,
          maximumCount === 0 ? 1 : maximumCount
        ]
        const caloriesDomain = {
          y: [
            minimumCalories,
            maximumCalories === 0 ? 1 : maximumCalories
          ]
        }
        const caloriesTickValues = [
          minimumCalories,
          maximumCalories === 0 ? 1 : maximumCalories
        ]
        const volumeDomain = {
          y: [
            minimumVolume,
            maximumVolume === 0 ? 1 : maximumVolume
          ]
        }
        const volumeTickValues = [
          minimumVolume,
          maximumVolume === 0 ? 1 : maximumVolume
        ]

        // Finding Averages
        const caloriesAverage = Math.round(totalCaloriesOfWeek / loggedWorkoutsOfWeekCount)
        const volumeAverage = Number(((totalVolumeOfWeek / volumeAvailableInWeekCount) / 1000).toFixed(1))
        const averageDuration = Math.round((totalDurationOfWeek / loggedWorkoutsOfWeekCount) / 60)

        return {
          countGraphData: countGraphData.reverse(),
          caloriesGraphData: caloriesGraphData.reverse(),
          volumeGraphData: volumeGraphData.reverse(),
          dates,
          countDomain,
          countTickValues,
          caloriesDomain,
          caloriesTickValues,
          volumeDomain,
          volumeTickValues,
          caloriesAverage: isNaN(caloriesAverage) ? 0 : caloriesAverage,
          volumeAverage: isNaN(volumeAverage) ? 0 : volumeAverage,
          averageDuration: isNaN(averageDuration) ? 0 : averageDuration
        }
      }
    }
  }
}
